module.exports = "<div ng-transclude></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpDefinitionList/adpDefinitionList.html
// module id = 513
// module chunks = 0